import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { type AccordionDescription } from "./AccordionCard";

interface AccordionDescriptionProps {
  description: AccordionDescription;
}

export function DescriptionRenderer({ description }: AccordionDescriptionProps) {
  if (typeof description === "string") {
    return <Text sx={(theme) => ({ color: theme.palette.text.secondary })}>{description}</Text>;
  }

  return (
    <Stack direction="row" gap={2}>
      <Text sx={(theme) => ({ color: theme.palette.text.secondary })}>{description.primary}</Text>
      {isDefined(description.secondary) && (
        <Text sx={(theme) => ({ color: theme.palette.text.tertiary })}>
          {description.secondary}
        </Text>
      )}
    </Stack>
  );
}
